import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useKarteTemplatesCacheUpdater } from "../../../hooks/http/useFetchKarteTemplates";
import { KarteTemplateFormInterface } from "../../../interfaces/KarteTemplateInterface";
import { useSectionKarteTemplateCacheUpdater } from "./useFetchSectionKarteTemplate";

export const useUpdateSectionKarteTemplate = ({
  sectionId,
  karteTemplateId,
}: {
  sectionId: string;
  karteTemplateId: string;
}) => {
  const { updateKarteTemplates } = useKarteTemplatesCacheUpdater();
  const { updateSectionKarteTemplate } = useSectionKarteTemplateCacheUpdater();

  return useBoronMutation(
    async (values: KarteTemplateFormInterface) =>
      await boronClient.PATCH(
        "/api/v1/sections/{section_id}/karte_templates/{karte_template_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              karte_template_hashid: karteTemplateId,
            },
          },
          body: {
            karte_template: {
              name: values.name,
              template: values.template,
            },
          },
        },
      ),
    {
      onSuccess: ({ karteTemplate }) => {
        updateKarteTemplates(sectionId, karteTemplate);
        updateSectionKarteTemplate(sectionId, karteTemplate);
      },
    },
  );
};
